export const util = {
  sidebarWidth: 270,
  erpGridMarginX: 32,
};
